module.exports = __webpack_public_path__ + "static/media/test14_3.37639c42.png";